import Settings from "../../components/settings.json";
import axios from "axios";
import config from "../../config/config";

export const genusAction = () => {
    return dispatch => {
        axios.get(`${config.BASE_URL}${Settings.genusUrl}`)
        .then(res => {
            dispatch({
                type: "GENUS_ACTION_SUCCESS",
                genusList: res.data,
            })
        }).catch(err => {
            dispatch({
                type:"GENUS_ACTION_ERROR",
            })
        });
    }
}